import { AnimatePresence } from "framer-motion";
import InputField from "../../components/inputfields/InputField";
import LoginModel from "../../components/Models/LoginModel";
import { useState } from "react";
import { validateInput } from "../../components/commonfunctions/validateInput";
import useApi from "../../services/useApi";
import { useDispatch } from "react-redux";
import { showToast } from "../../components/toastMessage/toastSlice";
import { useNavigate } from "react-router";
import useTranslation from "../../components/CustomHooks/useTranslation";
import { contents } from "./AuthContents";

export default function ForgotPassword() {
  //declared states that are used in the forgot password feature
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { PostAPI } = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate, replace } = useTranslation(contents?.["Forgot password"])

  const handleSubmit = async () => {
    //all the loading states and error states initialized here
    setError("");

    //checking if the email is not empty or null
    if (!email.trim()) {
      setError("This field is required");
      return;
    }

    //checking if the email is following the proper format and domain
    const errors = validateInput({ email_address: email.trim() });
    if (Object.keys(errors)?.length > 0) {
      setError(errors?.email_address);
      return;
    }

    //building payload here
    let body = {
      email_address: email.trim(),
    };

    // making API request here
    setLoading(true);
    const response = await PostAPI("admins/forgot-password", body);
    if (!response.error) {
      dispatch(showToast({ type: "info", message: replace(response?.data?.message, { email_address: email }) }));
      navigate("/");
    } else {
      console.error(response, "API ERROR");
      dispatch(
        showToast({
          type: "error",
          message: response?.data?.response?.data?.message,
        })
      );
    }
    setLoading(false);
  };
  return (
    <AnimatePresence>
      <LoginModel
        loginFlow
        heading={translate("Forgot Password")}
        buttonName={translate("Send Link")}
        handleSubmit={handleSubmit}
        loading={loading}
        forgotPassword={true}
        testId={translate("send-link")}
        mainImg="zood_pay_sidebar_img"
      >
        <div className="mt-5">
          <InputField
            inputItem={{ labelName: "Email Address", id: "Email Address" }}
            errorMessage={error}
            // Call handleInputChange, ensuring field names are 'email' or 'password'
            onChange={(e) => {
              setError("");
              email.length < 50 && setEmail(e.target.value);
            }}
            maxLength={50}
            tabIndex={1}
            className="w-full"
          />
        </div>
      </LoginModel>
    </AnimatePresence>
  );
}
